import { Tab } from "@headlessui/react";
import { useState, useEffect } from "react";

import classNames from "classnames";
import EmployeeDetailsForm from "./employeeDetailsForm";
import QualificationDetails from "./qualificationDetails";
import ExperienceDetails from "./experienceDetails";
import ProjectDetails from "./projectDetails";
import EmployeeDocuments from "./employeeDocuments";
import PaystubDetails from "./paystubDetails";
import BillingPeriodConfig from "./billingPeriodConfig";
import { getAllProjectsByUuid } from "../api/project-api";

// function classNames(...classes: string[]) {
//     return classes.filter(Boolean).join(" ");
// }

export default function EmployeeDetailsTabs(props: { profile: any; consultantDetails: any }) {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [projects, setProjects] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    // Load projects on component mount
    useEffect(() => {
        if (props.profile?.uuid) {
            getAllProjectsByUuid(props.profile.uuid).then((projectData: any) => {
                setProjects(projectData || []);
                setIsLoading(false);
            }).catch(() => {
                setIsLoading(false);
            });
        }
    }, [props.profile?.uuid]);

    // Check if any project uses customized billing period
    const hasCustomizedProject = projects.some(
        (project: any) => project.billing_period === "Customized"
    );

    const tabCss = "group relative focus:ring-0 focus:border-transparent min-w-0 flex-1 overflow-hidden py-2 px-4 text-sm font-medium text-center focus:z-0 absolute inset-x-0 bottom-0 ring-0 focus:ring-0";
    const activeTabCss = "bg-blue-900 text-white font-bold";
    const passiveTabCss = "bg-white text-black";

    return (
        <Tab.Group defaultIndex={1} selectedIndex={selectedIndex} onChange={setSelectedIndex}>
            <>
                <Tab.List className="relative z-0 flex divide-x divide-gray-200 rounded-lg shadow flex-wrap">
                    {/* <Tab className={classNames(tabCss, activeTabCss, passiveTabCss)}>Tab 1</Tab> */}
                    <Tab className={({ selected }) => classNames(tabCss, selected ? activeTabCss : passiveTabCss, "rounded-l-lg")}>Personnel Details</Tab>
                    <Tab className={({ selected }) => classNames(tabCss, selected ? activeTabCss : passiveTabCss)}>Qualifications</Tab>
                    <Tab className={({ selected }) => classNames(tabCss, selected ? activeTabCss : passiveTabCss)}>Experience</Tab>
                    <Tab className={({ selected }) => classNames(tabCss, selected ? activeTabCss : passiveTabCss)}>Project Details</Tab>
                    {hasCustomizedProject && !isLoading && (
                        <Tab className={({ selected }) => classNames(tabCss, selected ? activeTabCss : passiveTabCss)}>Billing Config</Tab>
                    )}
                    {/* <Tab className={({ selected }) => classNames(tabCss, selected ? activeTabCss : passiveTabCss)}>Travel Details</Tab> */}
                    <Tab className={({ selected }) => classNames(tabCss, selected ? activeTabCss : passiveTabCss, "")}>Paystub</Tab>
                    <Tab className={({ selected }) => classNames(tabCss, selected ? activeTabCss : passiveTabCss, "rounded-r-lg")}>Documents</Tab>
                </Tab.List>

                <Tab.Panels className={"pt-5"}>
                    <Tab.Panel>
                        <EmployeeDetailsForm profile={props.profile} />
                    </Tab.Panel>
                    <Tab.Panel>
                        <QualificationDetails consultantDetails={props.consultantDetails} />
                    </Tab.Panel>
                    <Tab.Panel>
                        <ExperienceDetails consultantDetails={props.consultantDetails} />
                    </Tab.Panel>
                    <Tab.Panel>
                        <ProjectDetails profile={props.profile} />
                    </Tab.Panel>
                    {hasCustomizedProject && !isLoading && (
                        <Tab.Panel>
                            <BillingPeriodConfig profile={props.profile} projects={projects} />
                        </Tab.Panel>
                    )}
                    <Tab.Panel>
                        <PaystubDetails profile={props.profile} />
                    </Tab.Panel>
                    {/* <Tab.Panel>
                        <EmployeeTravelDetails />
                    </Tab.Panel> */}

                    <Tab.Panel>
                        <EmployeeDocuments consultantDetails={props.consultantDetails} />
                    </Tab.Panel>
                </Tab.Panels>
            </>
        </Tab.Group>
    );
}
